import { Trash, TrashIcon } from "assests";
import { Button } from "components/UI/Button";
import { DotButton, useDotButton } from "components/UI/CarouselDotButton";
import useEmblaCarousel from "embla-carousel-react";

export default function ProductCarousel({
  imagePreviews,
  isArticleEditable,
  handleCertFileDelete,
}) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    loop: false,
    align: "start",
    slidesToScroll: 1,
  });

  const { selectedIndex, scrollSnaps, onDotButtonClick } = useDotButton(emblaApi);

  return (
    <div ref={emblaRef}>
      <div className="flex gap-8">
        {imagePreviews &&
          imagePreviews.length > 0 &&
          imagePreviews.map((entry, index) => {
            // const imageUrl = entry && new URL(entry, baseUrl).href;
            return (
              <div
                className="flex flex-col gap-4 justify-center items-center pt-4 min-w-0 grow-0 shrink-0 basis-12/12 w-full"
                key={index}
              >
                <div
                  key={entry.id}
                  className="min-w-0 grow-0 shrink-0 basis-12/12 max-w-[480px] w-full"
                >
                  <article className=" transition relative h-full">
                    <div className="relative">
                      <img
                        draggable="false"
                        className="overflow-hidden rounded-lg w-full h-[478px] object-contain object-center "
                        loading="lazy"
                        src={entry}
                        alt={`Preview ${index + 1}`}
                        width={1468}
                        height={277}
                        sizes="(max-width: 639px) calc(100vw - 34px), (max-width: 1024px) calc(50vw - 30px), 482px"
                      />
                    </div>
                  </article>
                </div>
                {isArticleEditable && (
                  <Button
                    type="button"
                    size={"md"}
                    variant={"secondary"}
                    className={
                      "w-[111px] text-txt-secondary-secondary bg-white  h-10 px-3 py-2.5 gap-1 text-base leading-6 font-semibold custom-outline-shadow hover:text-white"
                    }
                    style={{
                      boxShadow:
                        "0px 0px 0px 1px rgba(16, 24, 40, 0.18) inset, 0px -2px 0px 0px rgba(16, 24, 40, 0.05) inset, 0px 1px 2px 0px rgba(16, 24, 40, 0.05);",
                    }}
                    onClick={() => handleCertFileDelete(index)}
                  >
                    {isArticleEditable && (
                      <TrashIcon
                        strokeColor={"var(--color-global-paragraph-3)"}
                        className="cursor-pointer hover:text-white"
                      />
                    )}
                    Remove
                  </Button>
                )}
              </div>
            );
          })}
      </div>
      <div className="flex flex-col gap-4 justify-center items-center pt-4">
        <div className="flex gap-4 self-center ">
          {scrollSnaps.map((_, index) => (
            <DotButton
              aria-label={`Go to slide ${index + 1}`}
              key={index}
              onClick={() => onDotButtonClick(index)}
              className={"inline-block rounded-full w-[10px] h-[10px]  ".concat(
                index === selectedIndex ? "bg-global-primary" : "bg-global-gray-soft ",
              )}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
